import { z } from 'zod';
import { DEFAULT_PLAN_SLUGS, MP_PAYMENT_METHODS, SUBSCRIPTION_STATUSES } from '../constants.js';
import { planAILimitsSchema } from './ai.js';
import { slugSchema, uuidSchema } from './primitives.js';

export const planFeaturesSchema = z.object({
  workspaces_max: z.number().int().min(1).max(10_000).nullable().default(null),
  docs_max: z.number().int().min(1).nullable().default(null),
  assets_mb: z.number().int().min(0),
  seats: z.number().int().min(1).default(1),
  collab: z.boolean().default(false),
  share_public: z.boolean().default(false),
  export_pdf: z.boolean().default(false),
  api_access: z.boolean().default(false),
});
export type PlanFeatures = z.infer<typeof planFeaturesSchema>;

export const upsertPlanInput = z.object({
  slug: slugSchema,
  name: z.string().min(1).max(120),
  description: z.string().max(2000).optional(),
  price_brl: z.number().int().min(0),
  price_usd: z.number().int().min(0).nullable().default(null),
  trial_days: z.number().int().min(0).max(90).nullable().default(null),
  trial_requires_card: z.boolean().default(false),
  features: planFeaturesSchema,
  ai_limits: planAILimitsSchema,
  is_active: z.boolean().default(true),
  is_public: z.boolean().default(true),
});
export type UpsertPlanInput = z.infer<typeof upsertPlanInput>;

export const planSlugEnum = z.union([z.enum(DEFAULT_PLAN_SLUGS), slugSchema]);

export const checkoutInput = z.object({
  workspaceId: uuidSchema,
  planSlug: planSlugEnum,
  paymentMethod: z.enum(MP_PAYMENT_METHODS),
});
export type CheckoutInput = z.infer<typeof checkoutInput>;

export const subscriptionStatusEnum = z.enum(SUBSCRIPTION_STATUSES);

// Webhook payload Mercado Pago — campos mínimos que processamos.
export const mpWebhookPayload = z
  .object({
    id: z.union([z.string(), z.number()]).optional(),
    type: z.string().optional(),
    action: z.string().optional(),
    data: z.object({ id: z.union([z.string(), z.number()]) }),
  })
  .passthrough();
